module.exports = "/_next/static/images/1ec92fb2b79b91634a4e2bc3d2924443-girl-holding-phone@tablet2x.jpg";